import { ScaleLinear } from 'd3-scale';
import { deriveYAxisLabelProps } from '../axisLabel/deriveLabelProps';
import { YAxisLabelProps } from '../axisLabel/YAxisLabel';
import { NumberFormat } from '@instinet-analytics/core-lib';
import {
    arrivalTooltip,
    limitPriceTooltip,
    openPriceTooltip,
    prevCloseTooltip,
} from './help/orderFillsLegendTooltip';

export function deriveOrderFillsYAxisLabelProps(
    snapPrice: number | undefined,
    closePrice: number | undefined,
    limitPrice: number | undefined,
    open: number | undefined,
    numberFormat: NumberFormat,
    yScale: ScaleLinear<number, number>,
    height: number,
    width: number
): Record<'arrival' | 'close' | 'limit' | 'open', YAxisLabelProps | undefined> {
    return deriveYAxisLabelProps(
        [
            {
                key: 'arrival',
                type: 'Arrival',
                tooltip: arrivalTooltip,
                value: snapPrice,
            },
            {
                key: 'close',
                type: 'Prev Close',
                tooltip: prevCloseTooltip,
                value: closePrice,
            },
            {
                key: 'limit',
                type: 'Limit Price',
                tooltip: limitPriceTooltip,
                value: limitPrice,
            },
            {
                key: 'open',
                type: 'Open Price',
                tooltip: openPriceTooltip,
                value: open,
            },
        ],
        numberFormat.n2to4.bind(numberFormat),
        yScale,
        height,
        width
    );
}
